import Wizard from 'scoreboard/components/wizard'
import UploadUsersForm from './upload-users-form'
import ImportUsersPreview from './import-users-preview'

var views = [
 	UploadUsersForm,
	ImportUsersPreview
]

var ImportUsersWizard = Wizard.extend({

	initialize: function() {
		Wizard.prototype.initialize.call(this, { views: views })
	}

})

export default ImportUsersWizard

ImportUsersWizard.__filename__ = 'admin/principals/users/import/import-users-wizard.js'
